import { Beer, Coffee, Droplets, GlassWater, Martini, Sparkles, Utensils, Wine } from "lucide-react";

export const CATEGORY_ORDER = [
  "cocktails",
  "copas",
  "refrescos",
  "cervezas_botella",
  "cervezas_grifo",
  "vinos",
  "zumos",
  "cervezas",
  "sin_alcohol",
  "desayunos",
  "aperitivos",
  "raciones",
  "hamburguesas",
  "asados",
  "comida",
  "postres",
  "eventos",
];

export const CATEGORY_META = {
  cocktails:        { label:"Cocktails", group:"bebida", icon:Martini, short:"CO" },
  copas:            { label:"Licores", group:"bebida", icon:Wine, short:"LC" },
  refrescos:        { label:"Refrescos", group:"bebida", icon:GlassWater, short:"RF" },
  cervezas_botella: { label:"Cervezas", group:"bebida", icon:Beer, short:"CV" },
  cervezas_grifo:   { label:"De grifo", group:"bebida", icon:Beer, short:"GF" },
  vinos:            { label:"Vinos", group:"bebida", icon:Wine, short:"VI" },
  zumos:            { label:"Zumos", group:"bebida", icon:Droplets, short:"ZU" },
  cervezas:         { label:"Cervezas", group:"bebida", icon:Beer, short:"CV" },
  sin_alcohol:      { label:"Sin alcohol", group:"bebida", icon:GlassWater, short:"SA" },
  desayunos:        { label:"Desayunos", group:"comida", icon:Coffee, short:"DS" },
  aperitivos:       { label:"Aperitivos", group:"comida", icon:Utensils, short:"AP" },
  raciones:         { label:"Raciones", group:"comida", icon:Utensils, short:"RA" },
  hamburguesas:     { label:"Hamburguesas", group:"comida", icon:Utensils, short:"HB" },
  asados:           { label:"Asados", group:"comida", icon:Utensils, short:"AS" },
  comida:           { label:"Comida", group:"comida", icon:Utensils, short:"CM" },
  postres:          { label:"Postres", group:"comida", icon:Sparkles, short:"PO" },
  eventos:          { label:"Eventos", group:"comida", icon:Sparkles, short:"EV" },
};

export const GROUP_LABELS = { bebida:"Bebida", comida:"Comida" };

export const TAPA_EXTRA_PRICE = 2;

export const APERITIVO_CONFIG = {
  refrescos: { increment:0.65 },
  vinos: { increment:0.60 },
  cervezas_botella: { increment:0.70 },
  cervezas_grifo: { increment:0.70 },
  cervezas: { increment:0.70 },
  zumos: { increment:0.70 },
};

export function getAperitivoIncrement(category, variantData = null) {
  if (variantData && variantData.aperitivoIncrement !== undefined) {
    return variantData.aperitivoIncrement === null ? null : Number(variantData.aperitivoIncrement);
  }
  return APERITIVO_CONFIG[category]?.increment ?? null;
}

export function categoryHasAperitivo(category, variantData = null) {
  return getAperitivoIncrement(category, variantData) !== null;
}

export function variantPriceRange(product) {
  const variants = Array.isArray(product?.variants) ? product.variants : [];
  if (!variants.length) return null;
  const prices = variants.map(variant => Number(variant.price)).filter(Number.isFinite);
  if (!prices.length) return null;
  const min = Math.min(...prices);
  const max = Math.max(...prices);
  return min === max ? `${min.toFixed(2)} €` : `${min.toFixed(2)} - ${max.toFixed(2)} €`;
}

export function displayPrice(product) {
  return variantPriceRange(product) || money(product?.price);
}

export function getMeta(cat) {
  return CATEGORY_META[cat] || { label:cat?.replace(/_/g," ") || "Carta", group:"comida", icon:Sparkles, short:"NE" };
}

export function productId(product) {
  return product?._id || product?.id || `${product?.category}-${product?.name}`;
}

export function money(value) {
  const n = Number(value);
  return Number.isFinite(n) && n > 0 ? `${n.toFixed(2)} €` : "Consultar";
}

export function sortProducts(items) {
  return [...items].sort((a, b) => {
    if (Boolean(a.featured) !== Boolean(b.featured)) return a.featured ? -1 : 1;
    const pa = Number(a.price) > 0 ? Number(a.price) : Infinity;
    const pb = Number(b.price) > 0 ? Number(b.price) : Infinity;
    if (pa !== pb) return pa - pb;
    return String(a.name||"").localeCompare(String(b.name||""),"es");
  });
}

export function groupProducts(products) {
  const map = new Map();
  for (const product of products) {
    if (product.active === false) continue;
    const cat = product.category || "comida";
    if (!map.has(cat)) map.set(cat,[]);
    map.get(cat).push(product);
  }
  const known = CATEGORY_ORDER.filter(cat => map.has(cat));
  const unknown = [...map.keys()].filter(cat => !CATEGORY_ORDER.includes(cat))
    .sort((a,b) => getMeta(a).label.localeCompare(getMeta(b).label,"es"));
  return [...known,...unknown].map(cat => ({
    category:cat,
    meta:getMeta(cat),
    items:sortProducts(map.get(cat)),
  }));
}

// ── Hamburguesa extras ─────────────────────────────────────────────────────
export const BURGER_EXTRA_PREFIX = "Extra:";

/** Producto que es un extra personalizable de hamburguesa */
export function isBurgerExtra(product) {
  return (
    product?.category === "hamburguesas" &&
    String(product?.name || "").startsWith(BURGER_EXTRA_PREFIX)
  );
}

/** Producto que es una hamburguesa principal (no extra) */
export function isBurgerMain(product) {
  return (
    product?.category === "hamburguesas" &&
    !String(product?.name || "").startsWith(BURGER_EXTRA_PREFIX)
  );
}
